import $ from 'jquery';
import Isotope from 'isotope-layout';
import jQueryBridget from 'jquery-bridget';
import fitvids from 'fitvids';

jQueryBridget( 'isotope', Isotope, $ );


// Put the following code after isotope js include
// Override and customize Isotope FitRows layout mode: CENTER each rows
var fitRows = Isotope.LayoutMode.modes.fitRows.prototype;
fitRows._resetLayout = function() {

  // pre-calculate offsets for centering each row
  this.x = 0;
  this.y = 0;
  this.maxY = 0;
  this._getMeasurement( 'gutter', 'outerWidth' );
  this.centerX = [];
  this.currentRow = 0;
  this.initializing = true;
  for ( var i=0, len = this.items.length; i < len; i++ ) {
      var item = this.items[i];
      this._getItemLayoutPosition(item);
  }
  this.centerX[this.currentRow].offset = (this.isotope.size.innerWidth +this.gutter-this.x) / 2;
  this.initializing = false;
  this.currentRow = 0;

  // centered offsets were calculated, reset layout
  this.x = 0;
  this.y = 0;
  this.maxY = 0;
  this._getMeasurement( 'gutter', 'outerWidth' );
};
fitRows._getItemLayoutPosition = function( item ) {
  item.getSize();
  var itemWidth = item.size.outerWidth + this.gutter;
  // if this element cannot fit in the current row
  var containerWidth = this.isotope.size.innerWidth + this.gutter;
  if ( this.x !== 0 && itemWidth + this.x > containerWidth ) {

    if (this.initializing)
        this.centerX[this.currentRow].offset = (containerWidth-this.x) / 2;
    this.currentRow++;

    this.x = 0;
    this.y = this.maxY;
  }

  if (this.initializing && this.x == 0) {
    this.centerX.push({ offset: 0});
  }
  //if (this.centerX[this.currentRow].offset < 0)
  //  this.centerX[this.currentRow].offset = 0;

  var position = {
    x: this.x+(this.initializing?0:this.centerX[this.currentRow].offset),
    y: this.y
  };

  this.maxY = Math.max( this.maxY, this.y + item.size.outerHeight );
  this.x += itemWidth;

  return position;
};

/**
 * Mobile navigation toggle
 * @param  {mixed} event
 */
const toggleMenu = (event) => {
  event.preventDefault();
  $('.js-menu-toggle, .nav--header').toggleClass('open');
  $('.header').toggleClass('menu-open');
};
$('.js-menu-toggle').on('click', toggleMenu);

/* Navigate to Stakeholder page by dropdown */

$('[data-select="stakeholders"]').on('change', function () { // bind change event to select
    var url = $(this).val(); // get selected value
    if (url != '') { // require a URL
        window.location = url; // redirect
    }
    return false;
});

/* Filter Stakeholders by Profession */

$('[data-select="professions"]').on('change', function () { // bind change event to select
    var url = $(this).val(); // get selected value
    if (url != '') { // require a URL
        window.location = url; // redirect
    }
    return false;
});

$('form#professions_home').on('submit', function () { // bind change event to select
    var url = $('[name="profession"]', $(this)).val(); // get selected value
    if (url != '') { // require a URL
        window.location = url; // redirect
    }
    return false;
});

$( function() {

  var $grid = $('[data-isotope]');

  // bind filter button click
  var $filters = $('#filters').on( 'click', 'button', function() {
    var filterAttr = $( this ).attr('data-filter');
    // set filter in hash
    location.hash = 'filter=' + encodeURIComponent( filterAttr );
  });

  var isIsotopeInit = false;

  function onHashchange() {
    var hashFilter = location.hash.replace('#', '.');
    if (hashFilter == '.all')
    {
    	hashFilter = '*';
    }
    console.log(hashFilter);
    if ( !hashFilter && isIsotopeInit ) {
      return;
    }
    isIsotopeInit = true;
    // filter isotope
    $grid.isotope({
      itemSelector: '.grid-item',
      filter: hashFilter,
      layoutMode: 'fitRows',
    });
  }

  $(window).on( 'hashchange', onHashchange );
  // trigger event handler to init Isotope
  onHashchange();
});

 /**
   * Modals
   */

$('[data-trigger-modal]').on('click', function(e) {
    e.preventDefault();
    var modal = $(this).data('trigger-modal');
    $('[data-modal="' + modal + '"]').fadeIn();
});

$('[href="#newsletter"]').on('click', function(e) {
    e.preventDefault();
    $('[data-modal="newsletter"]').fadeIn();
});

$('.js-dismiss-modal').on('click', function(e) {
    e.preventDefault();
    $('[data-modal]').fadeOut();
});

$(document).keyup(function(e) {
    if (e.keyCode == 27) 
    {
        $('[data-modal]').fadeOut();
    }
});

 /**
   * Accordion
   */

  var allPanels = $('.accordion > dd').hide();
    
  $('.accordion > dt').click(function() {
    var target = $(this).next();
    var accordion = $(this).parent('.accordion');
    allPanels.slideUp();
    $('dt', accordion).removeClass('is-active');
    if (!target.is(':visible'))
    {
      target.slideDown();
    }
    $(this).toggleClass('is-active');
    return false;
  });


   /**
   * FitVids
   */

fitvids('.panel, main, section');